import road from '../../assets/road2.jpg';
import { getTrackById } from '../../assets/asset_loaders/tracks'
import './RoadPattern.css';

const RoadPattern = ({ selectedTrack, highlightedConnectionId, animationDuration = 2.5 }) => {
  const roadWidth = 10;
  const track2 = highlightedConnectionId ? getTrackById(highlightedConnectionId) : null;

  if (!selectedTrack || !track2) return null;

  const dx = track2.pos.x - selectedTrack.pos.x;
  const dy = track2.pos.y - selectedTrack.pos.y;
  const angle = Math.atan2(dy, dx) * 180 / Math.PI;
  let distance = Math.sqrt(dx * dx + dy * dy);

  if (selectedTrack.id === highlightedConnectionId) return null;

  return (
    <div
      className="road-pattern-container"
      style={{
        position: 'absolute',
        top: `${selectedTrack.pos.y}%`,
        left: `${selectedTrack.pos.x}%`,
        width: `calc(${distance}% - 10px)`,
        height: roadWidth,
        transform: `rotate(${angle}deg)`,
        zIndex: 1,
      }}
    >
      <div
        className="road-background-line"
        style={{
          width: '100%',
          height: '100%',
        }}
      />
      <div
        className="road-pattern"
        style={{
          width: '100%',
          height: '100%',
          '--animation-duration': `${animationDuration}s`,
          backgroundSize: `${roadWidth}px`,
          backgroundImage: `url(${road})`,
        }}
      />
    </div>
  );
};

export default RoadPattern;